import { render, staticRenderFns } from "./CreditRelated.vue?vue&type=template&id=ef3d2a44&"
import script from "./CreditRelated.vue?vue&type=script&lang=js&"
export * from "./CreditRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports